import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import reducers from "../reducers";
import { load, save } from "redux-localstorage-simple";
const composeEnhancers = (f) => f;

const store = createStore(
  reducers,
  load(),
  composeEnhancers(applyMiddleware(thunk, save({ ignoreStates: ["queries"] }))),
);

export default store;
